import { Controller } from "@hotwired/stimulus";

// Drives the "Link Payment to User" modal. A single modal instance is shared
// across all payment rows; the triggering dropdown button supplies the payment
// context (slug + current payer) via data attributes, which we read from the
// Bootstrap `show.bs.modal` event's relatedTarget.
export default class extends Controller {
  static targets = [
    "form", "submitBtn", "paymentSlug",
    "currentPayer", "currentPayerContainer"
  ];

  static values = { baseUrl: String };

  connect() {
    this._boundShow = this.onShow.bind(this);
    this._boundHide = this.onHide.bind(this);
    this._boundUserChange = this.onUserChange.bind(this);

    this.element.addEventListener("show.bs.modal", this._boundShow);
    this.element.addEventListener("hidden.bs.modal", this._boundHide);
    this._userInput?.addEventListener("app-select:change", this._boundUserChange);

    this._updateSubmitState();
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this._boundShow);
    this.element.removeEventListener("hidden.bs.modal", this._boundHide);
    this._userInput?.removeEventListener("app-select:change", this._boundUserChange);
  }

  onShow(event) {
    const trigger = event.relatedTarget;
    const slug = trigger?.dataset?.paymentSlug;
    const payer = trigger?.dataset?.paymentPayer;

    if (slug) {
      this.formTarget.setAttribute("action", `${this.baseUrlValue}/${slug}/link_payer`);
      this.paymentSlugTarget.textContent = slug;
    }

    if (payer && payer !== "Guest payer") {
      this.currentPayerTarget.textContent = payer;
      this.currentPayerContainerTarget.classList.remove("d-none");
    } else {
      this.currentPayerContainerTarget.classList.add("d-none");
    }

    this._resetUserSelect();
  }

  onHide() {
    this._resetUserSelect();
  }

  onUserChange() {
    this._updateSubmitState();
  }

  _updateSubmitState() {
    const hasUser = !!(this._userInput && this._userInput.value);
    if (this.hasSubmitBtnTarget) this.submitBtnTarget.disabled = !hasUser;
  }

  _resetUserSelect() {
    const input = this._userInput;
    if (!input) return;
    input.value = "";
    const wrapper = input.closest(".app-select");
    if (wrapper) {
      const label = wrapper.querySelector('[data-app-select-target="label"]');
      if (label) label.textContent = "Select a user";
      wrapper.querySelectorAll(".app-select-option").forEach((el) => {
        el.classList.remove("app-select-option-selected");
      });
      const search = wrapper.querySelector('[data-app-select-target="input"]');
      if (search) {
        search.value = "";
        search.dispatchEvent(new Event("input"));
      }
    }
    this._updateSubmitState();
  }

  get _userInput() {
    return this.element.querySelector('input[name="user_id"]');
  }
}
